<template>
  <h1 class="page-title"><slot/></h1>
</template>

<script>
export default {
  name: 'page-title'
}
</script>

<style scoped lang="scss">
.page-title {
  margin-bottom: 0;
  padding: 2.4rem 0;
  font-size: 2rem;
  font-weight: 400;
  text-align: center;

  @media (map_get($breakpoints, sm)) {
    font-size: 2.2rem;
  }

  @media (map_get($breakpoints, md)) {
    font-size: 3.2rem;
  }

  @media (map_get($breakpoints, lg)) {
    font-size: 3.6rem;
  }
}
</style>
